  import { Component, Vue, Watch } from 'vue-property-decorator';
import * as DashboardApiController from '../api/DashboardApiController';
import { DashboardFilterPostModel } from '../api/viewmodels/DashboardFilterPostModel';
import { StatusModel } from '../api/viewmodels/StatusModel';
import { AthleteModel } from '../api/viewmodels/AthleteModel';
import { ActivityModel } from '../api/viewmodels/ActivityModel';
import { ReferrerModel } from '../api/viewmodels/ReferrerModel';
import { AreaModel } from '../api/viewmodels/AreaModel';
import { SupplierModel } from '../api/viewmodels/SupplierModel';
import { SuitableForModel } from '../api/viewmodels/SuitableForModel';
import { ContactedFilterOptionModel } from '@/api/viewmodels/ContactedFilterOptionModel';
import FilterComponent from '../components/Filter.vue';
import Logo from '../components/logo.vue';
import * as MemberApiController from '../api/MemberApiController';

@Component({
  components: {
      FilterComponent,
      Logo
  }
})
export default class Dashboard extends Vue {

    get infoEmail() {
        if (window.location.host == 'dashboard.beweegcoach.nl') {
            return 'info@beweegcoach.nl';
        }

        return 's.levenswaard@rotterdamsportsupport.nl';
    }

    showLogoutMenu: boolean = false;

    showSnackbar: boolean = false;
    snackbarMessage: string = '';
    snackbarColor: string = '';

    footerOptions: any = {
        page: 1,
        itemsPerPage: 25
    }

    @Watch('footerOptions.page')
    onPageSelected(newVal: number) {
        this.filterDashboard();
    }

    showCommentDialog: boolean = false;
    commentDialogText: string = '';

    loading: boolean = false;

    editingItems: number[] = [];

    editSelectItems: any[] = [
        {
            text: 'Contact gehad',
            value: true
        },
        {
            text: 'Moet nog gebeld worden',
            value: false
        }
    ];

    tableHeaders: any[] = [
        {
            text: 'Naam',
            value: 'fullName',
            sortable: true
        },
        {
            text: 'Activiteit',
            value: 'activity',
            sortable: true
        },
        {
            text: 'Beweegaanbieder',
            value: 'supplierName',
            sortable: true
        },
        {
            text: 'Status',
            value: 'status',
            sortable: true
        },
        {
            text: 'Laatste wijziging',
            value: 'modifyDate',
            sortable: true
        },
        {
            text: '',
            value: 'data-table-expand',
            sortable: false
        }
    ]

    totalItems: number = 0;
    items: AthleteModel[] = [];

    activities: ActivityModel[] = [];
    selectedActivities: string[] = [];

    referrers: ReferrerModel[] = [];
    selectedReferrers: string[] = [];

    areas: AreaModel[] = [];
    selectedAreas: string[] = [];

    suppliers: SupplierModel[] = [];
    selectedSuppliers: string[] = [];

    statusses: StatusModel[] = [];
    selectedStatusses: string[] = [];

    contactedFilterOptions: ContactedFilterOptionModel[]  = [];
    selectedContactedFilterOptions: string[] = [];

    selectedSorting: any = {};
    sortingItems: any[] = [{ description: 'Naam', sortDesc: true }, { description: 'Laatste wijziging', sortDesc: true }];

    toggleSorting(item: any) {
      item.sortDesc = !item.sortDesc;
      this.selectedSorting = item;

      this.filterDashboard();
    }

    @Watch('selectedActivities')
    onSelectedActivitiesChanged(newVal: string[]) {
        this.footerOptions.page = 1;
        this.filterDashboard();
    }

    @Watch('selectedReferrers')
    onSelectedReferrersChanged(newVal: string[]) {
        this.footerOptions.page = 1;
        this.filterDashboard();
    }

    @Watch('selectedAreas')
    onSelectedAreasChanged(newVal: string[]) {
        this.footerOptions.page = 1;
        this.filterDashboard();
    }

    @Watch('selectedSuppliers')
    onSelectedSuppliersChanged(newVal: string[]) {
        this.footerOptions.page = 1;
        this.filterDashboard();
    }

    @Watch('selectedStatusses')
    onSelectedStatussesChanged(newVal: string[]) {
        this.footerOptions.page = 1;
        this.filterDashboard();
    }

    @Watch('selectedContactedFilterOptions')
    onSelectedContactedFilterOptionsChanged(newVal: string[]) {
        this.footerOptions.page = 1;
        this.filterDashboard();
    }

    onOptionsUpdated(options: any) {
        this.footerOptions = options;
    }

    created() {
        this.loading = true;
        var filterModel: DashboardFilterPostModel = {
            page: 0
        };

        DashboardApiController.getFilteredAthletes(filterModel)
            .then((result) => {
                var data = result.data;
                var role = data.role;
                this.$store.dispatch('setUserRole', role);

                this.activities = data.filters.activity?.filters ?? [];
                this.areas = data.filters.area?.filters ?? [];
                this.referrers = data.filters.referrer?.filters ?? [];
                this.statusses = data.filters.status?.filters ?? [];
                this.suppliers = data.filters.supplier?.filters ?? [];
                this.contactedFilterOptions = data.filters.contacted?.filters ?? [];

                this.totalItems = result.data.resultCount;
                this.items = result.data.results;
                this.setModifyDate();

                this.activities = this.activities.filter(a => a.filterHasAthletes);
                this.areas = this.areas.filter(a => a.filterHasAthletes);
                this.referrers = this.referrers.filter(a => a.filterHasAthletes);
                this.suppliers = this.suppliers.filter(a => a.filterHasAthletes);
                this.contactedFilterOptions = this.contactedFilterOptions.filter(a => a.filterHasAthletes);
                this.loading = false;
            })
            .catch((error) => {
                this.loading = false;
            });
    }

    filterDashboard() {
        this.loading = true;
        var filterModel: DashboardFilterPostModel = {
            activity: this.selectedActivities.length > 0 ? this.selectedActivities : undefined,
            area: this.selectedAreas.length > 0 ? this.selectedAreas : undefined,
            athlete: undefined,
            referrer: this.selectedReferrers.length > 0 ? this.selectedReferrers : undefined,
            status: this.selectedStatusses.length > 0 ? this.selectedStatusses : undefined,
            supplier: this.selectedSuppliers.length > 0 ? this.selectedSuppliers : undefined,
            contacted: this.selectedContactedFilterOptions.length > 0 ? this.selectedContactedFilterOptions : undefined,
            page: this.footerOptions.page-1
        };

        if (this.selectedSorting != null) {
          filterModel.sortDescription = this.selectedSorting.description;
          filterModel.sortDesc = this.selectedSorting.sortDesc;
        }

        DashboardApiController.getFilteredAthletes(filterModel)
            .then((result) => {
                this.totalItems = result.data.resultCount;
                this.items = result.data.results;
                this.setModifyDate();
                this.loading = false;
            })
            .catch((error) => {
                this.loading = false;
            });
    }

    getItemClass() {
        return "table-row";
    }

    getContactStatus(model: AthleteModel) {
        if (model == undefined) {
            return '';
        }

        return model.contacted ? 'Contact gehad' : 'Moet nog gebeld worden';
    }

    isEditingItem(item: AthleteModel) {
        return item != undefined && this.editingItems.find((val) => val == item.id) != undefined;
    }

    setEditingItem(item: AthleteModel, add: boolean) {
        if (add) {
            if (!this.isEditingItem(item) && item.id != undefined) {
                this.editingItems.push(item.id);
            }
        }
        else {
            if (this.isEditingItem(item) && item.id != undefined) {
                var index = this.editingItems.indexOf(item.id);
                this.editingItems.splice(index, 1);
            }
        }
    }

    saveAthlete(item: AthleteModel) {
        this.setEditingItem(item, false);

        // make a copy to prevent the original registration date from changing
        var objectAsJson = JSON.stringify(item);
        var objectCopy = <AthleteModel>JSON.parse(objectAsJson);
        var registrationDate = this.parseDate((<string>objectCopy.registrationDate)).toISOString();
        objectCopy.registrationDate = registrationDate;
        // because the item isn't a fully valid AthleteModel (it has a 'phone' field instead of a 'telephoneNumber' field), we need to cast it to any to be able to get the 'phone' field
        objectCopy.telephoneNumber = (<any>item).phone;

        if ((<any>objectCopy).modifyDateChanged) {
            if (objectCopy.modifyDate == "00-00-00") {
                objectCopy.modifyDate = new Date().toISOString();
                item.modifyDate = objectCopy.modifyDate.substr(0, 10);
            }
            else {
                var modifyDate = this.parseDate((<string>objectCopy.modifyDate)).toISOString();
                objectCopy.modifyDate = modifyDate;
            }            
        }
        else {
            objectCopy.modifyDate = new Date(0).toISOString()
            item.modifyDate = "00-00-00";
        }

        DashboardApiController.saveAthlete(objectCopy)
            .then((result) => {
                this.snackbarColor = 'success';
                this.snackbarMessage = 'Wijzigingen succesvol opgeslagen';
                this.showSnackbar = true;
                (<any>item).modifyDateChanged = false;
            })
            .catch((error) => {
                this.snackbarColor = 'error';
                this.snackbarMessage = 'Er was een fout bij het opslaan.\nProbeer het alstublieft opnieuw.';
                this.showSnackbar = true;
                (<any>item).modifyDateChanged = false;
            });
    }

    get canEditAthletes() {
        return this.$store.state.userRole == 'Admin' || this.$store.state.userRole == 'Aanbieders';
    }

    parseDate(date: string) {
        var re = date.match(/(\d{1,2})-(\d{1,2})-(\d{4}) (\d{2}):(\d{2}):(\d{2})/);
        if (re == null || re == undefined) {
            re = date.match(/(\d{4})-(\d{2})-(\d{2})/);
            if (re == null || re == undefined) {
                return new Date(0,0,0);
            }

            var day = parseInt(re[3]);
            var month = parseInt(re[2]) - 1;
            var year = parseInt(re[1]);
            return new Date(Date.UTC(year, month, day, 0, 0, 0));
        }

        if (re.length > 1) {
            var day = parseInt(re[1]);
            var month = parseInt(re[2]) - 1;
            var year = parseInt(re[3]);

            if (re.length > 3) {
                var hour = parseInt(re[4]);
                var minute = parseInt(re[5]);
                var second = parseInt(re[6]);

                return new Date(Date.UTC(year, month, day, hour, minute, second));
            }
            return new Date(Date.UTC(year, month, day, 0, 0, 0));
        }

        return new Date(0,0,0);
    }

    setModifyDate() {
        for (var item of this.items) {
            item.modifyDate = this.parseDate(item.modifyDate!).toISOString().substr(0, 10);
            if (item.modifyDate == "1970-01-01") {
                item.modifyDate = "00-00-00";
            }
        }        
    }

    saveModifiedDate(item: AthleteModel) {
        (<any>item).modifyDateChanged = true;
        this.saveAthlete(item);
    }

    logout() {
        MemberApiController.logout()
            .then((result) => {
                this.$store.dispatch('setLoggedOut');
                this.$store.dispatch('setUsername', '');
                this.$store.dispatch('setUserRole', '');
                this.$router.push('/');
            })
            .catch((error) => {
                // we don't have to do anything if this fails
            });
    }

    clearFilters() {
        this.selectedActivities = [];
        this.selectedAreas = [];
        this.selectedReferrers = [];
        this.selectedStatusses = [];
        this.selectedSuppliers = [];
    }
}
